// extracted by mini-css-extract-plugin
export default {"donut":"ResultsDonut_donut__ccNuS","value":"ResultsDonut_value__oqzuO","label":"ResultsDonut_label__GZHTX"};